























































import { Component, Vue } from 'vue-property-decorator';
import ListPanelComponent from '@/components/sales/saleslist/ListPanelComponent.vue';
import Select from '@/components/common/elements/Select.vue';
import HexabaseApi from '@/services/hexabase/hexabaseApi';
import hexabaseState from '@/store/hexabase';
import authState from '@/store/auth';
import ConstructionModel from '@/models/constructionModel';
import { ItemActions } from '@/services/hexabase/types';

@Component({
  components: {
    ListPanelComponent,
    Select
  }
})
export default class ConstructionBase extends Vue {
  private hexabaseApi = new HexabaseApi();
  private errorMess = '';
  private authState = authState;

  private targetPeriod = '';

  private lastTargetPeriod = '';
  private targetPeriodList: any = {};

  private async mounted() {
    const params = {
      conditions: [],
      page: 1,
      'per_page': 0,
      'use_display_id': true,
      'sort_field_id': 'construction_no',
      'sort_order': 'desc'
    };
    const salesList = await this.hexabaseApi.getItems(
      authState.token,
      hexabaseState.applicationId,
      hexabaseState.datastoreIds['工事'],
      params
    );
    if (salesList.length > 0) {
      const salesListGroup = salesList.reduce(function(result: any, current: any) {
        const element = result.find(function(p: any) {
          return p.period === current.period;
        });
        if (element) {
          element.count++; // count
        } else {
          result.push({
            period: current.period,
            count: 1
          });
        }
        return result;
      }, []);
      salesListGroup.sort(function(a: any, b: any) {
        if (a.period < b.period) return 1;
        if (a.period > b.period) return -1;
        return 0;
      });
      this.lastTargetPeriod = salesListGroup[0].period ? salesListGroup[0].period : '';
      this.targetPeriodList = {
        name: 'targetPeriodList',
        disabled: false,
        select: { value: this.lastTargetPeriod, text: this.lastTargetPeriod },
        options: []
      };
      for (const key in salesListGroup) {
        if (salesListGroup[key].period)
          this.targetPeriodList.options.push({
            value: salesListGroup[key].period,
            text: salesListGroup[key].period
          });
      }
      this.targetPeriod = this.lastTargetPeriod;
      // ダミー工事アイテムIDセット
      this.dummyConstructionItemId = salesList[0]['i_id'];
    }
  }

  get refs():any {
    return this.$refs;
  }

  private onSubmit() {
    this.refs.listPanelComponent.createSalesListData(this.targetPeriod);
  }

  private changeTargetPeriod(obj: { name: string; value: string }): void {
    const value = obj.value;
    this.targetPeriod = value;
  }

  private async tabChange(index: any) {
    this.currentTab = index;
  }

  // ダミー工事アイテムID（APIパラメータ用）
  private dummyConstructionItemId = '';
  // 工事ドメインモデル
  private constructionModel = new ConstructionModel();
  // アイテムアクション
  private itemActions: Array<ItemActions> = [];
  // 帳票出力アクション
  private outPutActionName = '売上・請求残一覧出力';

  /**
   * 該当のアクションをたたいて帳票をダウンロードする
   * @module downloadFile
   */
  private async downloadFile() {

    // 帳票セレクトボックスのvalueから叩くアクション名を取得
    const actionName = this.outPutActionName;

    // 既存アイテムを取得しアイテム情報・アクション情報を保持
    const constructionBasicResult = await this.constructionModel.getLinkedItems(
      hexabaseState.applicationId,
      hexabaseState.datastoreIds['工事'],
      this.dummyConstructionItemId
    );

    constructionBasicResult.item_actions.forEach(v => this.itemActions.push(v));

    const fileAction = this.itemActions.find(function(v) {
      if (v.action_name === actionName) {
        return v;
      }
    });

    if (fileAction) {
      try {
        this.$store.commit('hexabase/setIsLoading', true);

        // 帳票出力用のアクションを実行(帳票ファイルデータを生成し、Hexabaseへ保存し、ファイルIDなどをreturn)
        const fileActionResponse = await this.constructionModel.executeAction(
          hexabaseState.applicationId,
          hexabaseState.datastoreIds['工事'],
          this.dummyConstructionItemId,
          fileAction.display_id,
          {
            "return_item_result": true,
            "is_force_update": true,
            "as_params": {"period": this.targetPeriod}
          }
        );

        // アクションスクリプトが想定通り終了したかをチェック(アクションスクリプト未定義などを防ぐ目的。reject()でreturnされたらfileActionResponse.data.detailsに入るはず)
        if (!fileActionResponse.data.details) {
          console.log("error : No fileActionResponse.data.details");
          this.$store.commit('hexabase/setIsLoading', false);
          return false;
        }

        // ファイルダウンロード
        const fileActionResult = fileActionResponse.data.details.result;
        if (fileActionResult.status === 200) {
          const res = this.constructionModel.getXlxsFileDownload(
            fileActionResult.file_id,
            fileActionResult.file_name
          );
        } else {
          // 帳票出力エラー時
          console.log("error : File download NG", fileActionResult);
        }
      } catch (error) {
        console.error(error);
      }
    }
    this.$store.commit('hexabase/setIsLoading', false);
  }

  currentTab = 0;
  id = 0;
  tabName = '';
  tabs = [
    { id: 1, tabName: '売上・請求残一覧表' },
    { id: 2, tabName: '売上集計' }
  ];
}
